import { render, staticRenderFns } from "./GlideSlide.vue?vue&type=template&id=28f23117&"
import script from "./GlideSlide.vue?vue&type=script&lang=js&"
export * from "./GlideSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports